var GeoAPI = require('../../api').GeoMatch;
var DualListBoxDirective = require('../dualListBox');
var angular = require('angular');

var module = angular
  .module('app.directives')
  .directive('ngGeoMatching', function (ngDialog) {

    return {
      restrict: 'E',
      scope: {},
      require: 'ngModel',
      replace:true,
      template: require('./geomatch.pug'),
      link: function (scope, element, attrs, ngModel) {
        scope.publicFacing = (attrs.defaultToPlaces === 'true');

        scope.areas = [];
        scope.selectedAreas = [];

        ngModel.$render = function(){
          scope.selectedAreas = ngModel.$viewValue || [];
        }

        scope.change = function(){
          ngModel.$setViewValue(scope.selectedAreas.length ? scope.selectedAreas : null);
        }


        scope.filterChanged = function () {
          if (scope.filter.length < 3) {
            scope.areas = [];
            return;
          }
          scope.loading = true;
          GeoAPI.GetGeoMatchTree(scope.filter || '', scope.publicFacing).then(function (result) {
            scope.areas = result;
          }).finally(function(){
            scope.loading = false;
          })
        }

      }
    }

  })
